import type { FaireProductEntity } from "../../entity_types/product";

export const p_3kmzkcyhgq: FaireProductEntity = {
  token: "p_3kmzkcyhgq",
  type: "product",
  name: "Ritter Sport Milk Pistachio 100g Limited (Germany)",
  brandToken: "b_s2gzfhxg44",
  brandName: "Global Bite Co",
  imageUrl:
    "https://cdn.faire.com/fastly/ec2df5f28bbb982bbdca4d7c78a7dd35ffce383dda16b85922a4ff6610f8ef06.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3ea6461aab740989519f902db054f7dadacea3f7a3325e3b3c504f9e744963a4.jpeg",
  ],
  priceDollars: 4.16,
  description:
    "Ritter Sport Milk Pistachio 100 g (Germany) is an imported, exotic snack featuring creamy milk chocolate studded with roasted, lightly salted pistachio pieces. Crafted from 100% certified cocoa, it delivers a perfect balance of sweet and savory with a satisfying crunch. This beloved German treat offers global flavours and a taste that’s truly unique—ideal for nut-loving chocolate enthusiasts seeking a premium indulgence.\n",
  tags: [],
  msrpDollars: 8.59,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:34.312Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
